<template>
<div class="bBox">
  <div class="footerPage">
    <div class="left">
      <div class="disp">
        <ul>
          <li class="title">导航</li>
          <li class="curs" @click="toPage('1')">职位搜索</li>
          <li class="curs" @click="toPage('2')">个人中心</li>
          <li class="curs" @click="toPage('3')">个人简历</li>
        </ul>
        <ul>
          <li class="title">联系我们</li>
          <li>联系电话：010-64575166</li>
          <li>联系地址：北京市顺义区后沙峪镇绿地启航国际南区2号楼704</li>
          <li>电子邮箱：service@gogowork.cn</li>
        </ul>
        <ul>
          <li class="title">帮助</li>
          <li class="curs" @click="toPage('4')">意见反馈</li>
          <li class="curs" @click="toPage('5')">关于我们</li>
          <li class="curs" @click="moreCityFlag=true">电子营业执照</li>
        </ul>
      </div>
      <div class="dis bos">
        <p class="curs" @click="toPage('6')">京ICP备2021019219号-1</p>
        <!-- <p class="curs d" @click="toPage('7')"><img src="../../assets/jh.png" alt=""> 京公网安备 11011302005897号</p> -->
        <p>人力资源证书编号：（京）人服证字(2022)第1000001113号</p>
      </div>
    </div>
    <div class="right">
      <div>
        <img :src="$Static+'/svg/mini-qrcode.jpg'" alt />
        <p>GOGO直聘小程序</p>
      </div>
      <div>
        <img :src="$Static+'/svg/js-qrcode.jpg'" alt />
        <p>GOGO直聘公众号</p>
      </div>
    </div>
    <el-dialog
      title=" "
      :visible.sync="moreCityFlag"
      :close-on-click-modal="true"
      :modal-append-to-body="false">
     <div class="diaBox">
       <img :src="$Static+'/auth/yyzz.jpg'" alt/>
     </div>
    </el-dialog>
  </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      moreCityFlag:false
    };
  },

  mounted() {},

  methods: {
    // 跳转
    toPage(type) {
      switch (type) {
        case "1":
          this.$router.push("/mainPerson/positionList");
          break;
        case "2":
          if (window.localStorage.getItem("goToken")) {
            this.$router.push("/mainPerson/personalCenter");
          } else {
            this.$message.warning("请先登录");
          }
          break;
        case "3":
          if (window.localStorage.getItem("goToken")) {
            this.$router.push("/mainPerson/onlienVitae");
          } else {
            this.$message.warning("请先登录");
          }
          break;
        case "4":
          this.$router.push("/mainPerson/Feedback");
          break;
        case "5":
          window.open(this.$configUrl+'/cms/article/2023080774746189')
          break;
        case "6":
          window.open('https://beian.miit.gov.cn/')
          break;
        case "7":
          window.open('https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11011302005897')
          break;
      }
    }
  }
};
</script>

<style scoped>
.bBox{
  background: #323438;
  width: 100%;
  height: 200px;
}
.footerPage {
  width: 1200px;
  height: 200px;
  margin: 0 auto;
  padding: 30px 0 42px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.footerPage .vis {
  visibility: hidden;
}

.footerPage p,
li {
  font-size: 12px;
  font-weight: normal;
  line-height: 24px;
  color: rgba(255, 255, 255, 0.8);
}

.footerPage .left {
  width: 612px;
}

.footerPage .left .title {
  font-size: 14px;
  margin-bottom: 6px;
  color: #fff !important;
}

.footerPage .left .bos {
  margin-top: 14px;
}

.footerPage .left .bos p {
  margin-right: 50px;
}

.footerPage .right {
  display: flex;
  align-items: center;
  text-align: center;
  margin-top: 4px;
}

.footerPage .right div {
  margin-right: 60px;
}

.footerPage .right img {
  border: 8px solid #fff;
  width: 84px;
  height: 84px;
  margin-bottom: 8px;
}
.footerPage .right p{
  color: #fff !important;
}
.footerPage .d{
  display: flex;
  align-items: center;
}
.footerPage .d img{
  margin-right: 5px;
}
.diaBox{
  text-align: center;
}
.diaBox img{
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/view/common/footer.vue